'use client'

import useSWR from 'swr'
import type { SWRResponse } from 'swr'
import { Shows } from '@/lib/useShowsAPI'
import { JanApiResponse } from '@/app/api/jan/route'

const fetcherShows = async (uri: URL | RequestInfo): Promise<Shows> => {
  const response = await fetch(uri)
  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`fetcherShows failed: ${response.status} - ${errorText}`)
  }

  const result = (await response.json()) as unknown as Shows
  return result
}

const fetcherJan = async (uri: URL | RequestInfo): Promise<JanApiResponse> => {
  const response = await fetch(uri)
  // @@TODO: Use schema validation with zod or alternative.
  const result = (await response.json()) as unknown as JanApiResponse
  return result
}

// @@TODO: Extract API paths to environment variables.
export default function Products() {
  const { data: dataJan, error: errorJan }: SWRResponse<JanApiResponse, Error> =
    useSWR('/api/jan', fetcherJan)

  const { data: dataShows, error: errorShows }: SWRResponse<Shows, Error> =
    useSWR('/api/shows', fetcherShows)

  let jan
  if (errorJan instanceof Error) {
    jan = <div>oops... {errorJan.message}</div>
  } else if (dataJan === undefined) {
    jan = <div>Loading...</div>
  } else {
    jan = JSON.stringify(dataJan, null, 2)
  }

  let shows
  if (errorShows instanceof Error) {
    shows = <div>oops... {errorShows.message}</div>
  } else if (dataShows === undefined) {
    shows = <div>Loading...</div>
  } else {
    console.log('dataShows=', dataShows)
    shows = JSON.stringify(dataShows, null, 2)
    console.log('shows=', shows)
  }

  return (
    <div>
      <h1 className="text-2xl font-bold">Jan</h1>
      <div>jan:{jan}</div>
      <div>shows:{shows}</div>
    </div>
  )
}
